import React from "react";
import axios from "axios";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function AddDonation() {
  const wsUrl = "https://ws.scool-corner-web-api.pl";
  //const wsUrl = "http://localhost:3001";
  
  const initialValues = {
    name: "",
    amount: ""
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Imię nie może być puste"),
    amount: Yup.number()
      .positive("Kwota musi być dodatnia")
      .test("is-decimal", "Maksymalnie 2 miejsca po przecinku", (value) =>
        (value + "").match(/^(\d{1,5}|\d{0,5}\.\d{1,2})$/)
      )
      .required("Kwota nie może być pusta")
  });

  const onSubmit = (data) => {
    data.type = 1;
    data.remainingAmount = data.amount;
    axios
      .post(`${wsUrl}/donations`, data, {
        withCredentials: true,
        headers: {
          accessToken: localStorage.getItem("accessToken"),
          'Content-Type': 'application/json'
        },
      })
      .then((response) => {
        navigate("/admin");
      })
      .catch(error => {
        console.log("There is an error!", error)
      })
    };

  let navigate = useNavigate();

  useEffect(()=>{
    document.getElementById('body').style.backgroundColor = `rgb(215,128,23)`;
  })

  return (
    <div className="addDonationPage">
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form className="formContainer">
            <label>Imie: </label>
            <ErrorMessage name="name" component="span" />
            <Field
              className="formInput"
              name="name"
              placeholder=""
              type="text"
              autoComplete="off"
            />
            <label>Kwota: </label>
            <ErrorMessage name="amount" component="span" />
            <Field
              className="formInput"
              name="amount"
              placeholder=""
              type="number"
              autoComplete="off"
            />
            <button type="submit">
              Wesprzyj!
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddDonation;
